export default "__VITE_ASSET__DFqhvBO6__$_?src__"